
import React from 'react';
import { motion } from 'framer-motion';

export default function Footer() {
  return (
    <motion.footer
      className="mt-12 mb-8"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.5, duration: 0.6 }}
    >
      {/* Divider */}
      <div className="h-px bg-notion-border mb-6"></div>

      <div className="flex items-center justify-between text-[12px] text-notion-secondary">
        <div className="flex items-center gap-4">
          <a
            href="mailto:annieding000@gmail.com"
            className="hover:text-notion-text transition-colors cursor-pointer"
            rel="nofollow"
          >
            annieding000@gmail.com
          </a>
          <a
            href="https://www.linkedin.com/in/annieding04/"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="hover:text-notion-text transition-colors cursor-pointer"
          >
            LinkedIn
          </a>
        </div>

        <span className="font-serif text-[13px] text-notion-text">annie</span>
      </div>
    </motion.footer>
  );
}
